export const QUESTION_PRESCREENING_TYPE = 'pre-screening';
export const QUESTION_SUPPLEMENTARY_TYPE = 'supplementary';


// WEBPACK FOOTER //
// ./src/constants/question-types.js